<template>
  <div class="snackbars-container pa-2">
    <EcsSnackbar
      v-for="snackbar in snackbars"
      :key="snackbar.id"
      :snackbar="snackbar"
      :theme-mode="theme.getThemeMode"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsSnackbar from '@/components/ecs-snackbar/EcsSnackbar';
export default {
  name: 'EcsSnackbarList',
  components: { EcsSnackbar },
  computed: mapGetters(['snackbars', 'theme'])
};
</script>

<style scoped>
.snackbars-container {
  position: fixed;
  display: flex;
  flex-flow: column;
  justify-content: flex-end;
  bottom: 0;
  z-index: 100;
}
</style>
